import * as React from 'react';
import { toast } from '@/components/ui/use-toast';

type Action = {
  text: string;
  onClick: () => void;
};

export const useNotify = () => {
  const notify = React.useCallback(
    (
      text: string,
      toastType: 'success' | 'error' | 'loading' | 'blank' | 'custom' = 'success',
      duration?: number,
      action?: Action
    ) => {
      // Map react-hot-toast types to ShadCN toast variants
      const variant = toastType === 'error' ? 'destructive' : 'default';

      return toast({
        title: text,
        variant,
        duration: duration || 5000,
        ...(action && {
          action: (
            <button onClick={action.onClick} className="text-sm font-medium underline">
              {action.text}
            </button>
          )
        })
      });
    },
    []
  );

  return notify;
};
